import { render, staticRenderFns } from "./SabbaticalLeaveStatistical.vue?vue&type=template&id=6efc76a4&scoped=true&"
import script from "./SabbaticalLeaveStatistical.vue?vue&type=script&lang=js&"
export * from "./SabbaticalLeaveStatistical.vue?vue&type=script&lang=js&"
import style0 from "./SabbaticalLeaveStatistical.vue?vue&type=style&index=0&id=6efc76a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc76a4",
  null
  
)

export default component.exports